import React from 'react';

// Utils
import classNames from 'classnames';

type Props = {
  ariaLabel?: string;
  className?: string;
  dataTestId?: string;
  description?: string;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  loading?: boolean;
  title: string;
  to?: string;
  onClick?: (event: React.MouseEvent) => void;
};

const ModalCardButton = ({ ariaLabel, className, description, loading, title, to, icon: Icon, onClick, dataTestId = 'modalCardButton' }: Props) => {
  const Tag = to ? 'a' : 'button';
  const loadingClass = loading ? 'loading' : '';

  return (
    <Tag
      href={to}
      className={classNames('modal-card', loadingClass, className)}
      onClick={onClick}
      type="button"
      data-testid={dataTestId}
      aria-label={ariaLabel ?? title}
    >
      {loading && (
        <div className="icon-spinner-container">
          <i className="icon-spinner" />
        </div>
      )}
      {Icon && <Icon className="icon" />}
      {title && <h5 className="title">{title}</h5>}
      {description && <p className="description">{description}</p>}
    </Tag>
  );
};

export default ModalCardButton;
